import moment from 'moment';

const pending_fields = {
  'BL/Booking': 'doc_number',
  'Cantidad de contenedores': {
    field: 'requeriments',
    callback: requeriments => {
      return requeriments.length
    }
  },
  'Referencia': 'reference',
  'Tipo de servicio': 'service_type.name',
  'Linea naviera': {
    field: 'shipping_line',
    callback: shipping_line => {
      return shipping_line ? shipping_line.name : 'No indicada'
    } 
  },
  'Fecha (cita)': {
    field: 'requeriments',
    callback: requeriments => {
      return moment(requeriments[0].date).isValid() ? moment(requeriments[0].date).format('DD/MM/YYYY HH:mm') : ''
    }
  } 
}

export default pending_fields;